import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { useAuth } from "./auth/AuthContext";
import { db } from "./firebase";

export default function MyOddventureGames({
  title = "My Chadventure Tables",
  headingLevel = 2,
  layout = "grid",
  style = {},
}) {
  const { user } = useAuth();
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) {
      setTables([]);
      setLoading(false);
      return;
    }
    const qy = query(
      collection(db, "oddventure_tables"),
      where("ownerId", "==", user.uid),
      orderBy("createdAt", "desc")
    );
    const unsub = onSnapshot(
      qy,
      (snap) => {
        setTables(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error("[MyOddventureGames] load", err);
        setError(err.message || "Failed to load tables.");
        setLoading(false);
      }
    );
    return () => unsub();
  }, [user]);

  if (!user) {
    return (
      <section style={{ marginTop: 32, ...style }}>
        <p>Please sign in to see your Chadventure tables.</p>
      </section>
    );
  }

  const HeadingTag = headingLevel === 3 ? "h3" : "h2";
  const cardsStyle = layout === "stack"
    ? { display: "flex", flexDirection: "column", gap: 12, marginTop: 12 }
    : { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16, marginTop: 16 };

  const cardStyle = layout === "stack"
    ? { border: "1px solid #ddd", borderRadius: 10, padding: 12 }
    : { border: "1px solid #e0e0e0", borderRadius: 12, padding: 16 };

  return (
    <section style={{ marginTop: 32, ...style }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <HeadingTag style={{ margin: 0 }}>{title}</HeadingTag>
        <Link to="/oddventure" style={{ fontSize: 14 }}>Open Chadventure →</Link>
      </div>

      {error && (
        <div style={{ border: "1px solid #e57373", background: "#ffebee", padding: 12, borderRadius: 8, marginTop: 12 }}>
          {error}
        </div>
      )}

      {loading ? (
        <p style={{ marginTop: 12 }}>Loading tables…</p>
      ) : tables.length === 0 ? (
        <p style={{ marginTop: 12 }}>No tables yet. Start one and share the link.</p>
      ) : (
        <div style={cardsStyle}>
          {tables.map((table) => (
            <div key={table.id} style={{ ...cardStyle, display: "grid", gap: 6 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <div style={{ fontWeight: 700 }}>{table.name || "Chadventure Table"}</div>
                <div style={{ fontSize: 12, opacity: 0.7 }}>ID: {table.id}</div>
              </div>
              <div style={{ fontSize: 13, opacity: 0.85 }}>
                Seed {table.seed} • Code {table.code}
              </div>
              <div style={{ fontSize: 13, color: "#444" }}>
                Characters: {Number((table.characters || []).length)} • Discovered: {Number((table.discovered || []).length)}
              </div>
              {table.createdAt?.toDate && (
                <div style={{ fontSize: 12, opacity: 0.75 }}>
                  Created {table.createdAt.toDate().toLocaleString()}
                </div>
              )}
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 6 }}>
                <Link to={`/oddventure/${table.id}`} style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #1976d2" }}>
                  Open table
                </Link>
                <Link to={`/oddventure/${table.id}`} style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #9c27b0", color: "#9c27b0" }}>
                  Share link
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
